export default __webpack_public_path__ + "static/media/X.c08c8404.jpg";